import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { LoyaltySummaryListComponent } from './summary-list/summary-list.component';
import { LoyaltySummaryDetailComponent } from './summary-details/summary-detail.component';
const routes: Routes = [
    { path: 'loyalty', component: LoyaltySummaryListComponent, canActivate: [AuthGuard] },
    { path: 'loyalty-details', component: LoyaltySummaryDetailComponent, canActivate: [AuthGuard] }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LoyaltyRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/loyalty/loyalty-routing.module.ts